import { useCurrentUser } from '../../../../../shared/features/session/components/CurrentUserProvider';

/** What the signed-in user may do with receipts. Hiding what they can't is UX only; the server decides (CLAUDE.md → Web conventions). */
export function useReceiptPermissions() {
  const { state } = useCurrentUser();
  const permissions = state.status === 'authenticated' ? state.user.permissions : [];
  return {
    canRecord: permissions.includes('payment.record'),
    // The history endpoint is gated on `audit.view`, which billing.view does not imply, so the detail page shows the timeline only to holders of it.
    canViewHistory: permissions.includes('audit.view'),
  };
}
